import {Component, Inject, OnInit} from '@angular/core';
import {APP_CONFIG, AppConfig} from './core/config/app-config';
import {FaviconService} from './core/services/favicon.service';

import { OidcSecurityService, UserDataResult } from 'angular-auth-oidc-client';
// import { Router } from '@angular/router';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {

  isAuthenticated = false;
  userName: string = '';

  constructor(
    @Inject(APP_CONFIG) private config: AppConfig,
    private faviconService: FaviconService,
    private oidcSecurityService: OidcSecurityService,
    // private router: Router

  ) {}

  ngOnInit(): void {
    this.setThemeFromConfig();
    this.oidcSecurityService.checkAuth().subscribe(({ isAuthenticated }) => {
      this.isAuthenticated = isAuthenticated;
      if (isAuthenticated) {
        this.oidcSecurityService.userData$.subscribe((userData: UserDataResult) => {
          if (userData && userData.userData) {
            this.userName = userData.userData.name || 'Unknown User'; // Extract name from userData.userData
          }

          // Extract `group_names` claim
          const groupNames = userData.userData['group_names'] || [];
          
          // Store in sessionStorage (or localStorage if needed)
          sessionStorage.setItem('organizations', groupNames );
        
        });
      }
    });
  }

  private setThemeFromConfig() {
    window.document.body.classList.add(this.config.theme);
    this.faviconService.setFavicon(this.config.brandFaviconSrc);
  }

  login() {
    this.oidcSecurityService.authorize();
  }

}
